<div class="login-page">
  <!-- Left panel: form -->
  <div class="login-form-panel">
    <div class="form-panel-content">
      <!-- Top bar: logo left, language right -->
      <div class="top-bar">
        <div class="brand-logo">
          <img  width="100"  src="assets/img/RS_White bkgrnd.svg" alt="" srcset="">
          
        </div>
        <app-language-selector></app-language-selector>
      </div>

      <!-- Form centered -->
      <div class="form-wrapper">
        <div class="form-header">
          <h2>{{ i18n.get('login.welcome') }}</h2>
          <p>{{ i18n.get('login.subtitle') }}</p>
        </div>

        <form [formGroup]="formGroup" (ngSubmit)="login()" class="login-form">
          <div class="field-group">
            <mat-form-field appearance="outline">
              <mat-label>{{ i18n.get('login.email') }}</mat-label>
              <input matInput formControlName="email" type="email" autocomplete="email" [placeholder]="i18n.get('login.emailPlaceholder')" />
              @if (formGroup.controls.email.hasError('required')) {
                <mat-error>{{ i18n.get('login.validation.emailRequired') }}</mat-error>
              } @else if (formGroup.controls.email.hasError('email')) {
                <mat-error>{{ i18n.get('login.validation.emailInvalid') }}</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ i18n.get('login.password') }}</mat-label>
              <input matInput formControlName="password" [type]="showPassword ? 'text' : 'password'" [autocomplete]="showPassword ? 'off' : 'current-password'" [placeholder]="i18n.get('login.passwordPlaceholder')" />
              <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword" tabindex="-1" [attr.aria-label]="i18n.get('login.showPassword')">
                <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              @if (formGroup.controls.password.hasError('required')) {
                <mat-error>{{ i18n.get('login.validation.passwordRequired') }}</mat-error>
              } @else if (formGroup.controls.password.hasError('minlength')) {
                <mat-error>{{ i18n.get('login.validation.passwordMinLength') }}</mat-error>
              }
            </mat-form-field>
          </div>

          @if (loginError$ | async) {
            <div class="error-banner">
              <mat-icon>error_outline</mat-icon>
              <span>{{ i18n.get('login.errorCredentials') }}</span>
            </div>
          }

          <button
            mat-raised-button
            class="login-button"
            type="submit"
            [disabled]="formGroup.invalid || (loading$ | async)"
          >
            @if (loading$ | async) {
              <mat-spinner diameter="22" class="button-spinner"></mat-spinner>
            } @else {
              {{ i18n.get('login.submit') }}
            }
          </button>
        </form>
      </div>

      <!-- Footer bottom -->
      <div class="form-footer">
        <span>© Resident Select {{ currentYear }}</span>
        <span class="footer-email">
          <mat-icon class="footer-email-icon">mail_outline</mat-icon>
          help&#64;residentselectcol.com
        </span>
      </div>
    </div>
  </div>

  <!-- Right panel: image -->
  <div class="login-image-panel">
    <img src="assets/img/building.jpg" alt="Building lobby" />
  </div>
</div>
